import classNames from 'classnames';
import { FC, useContext } from 'react';
import { useNavigate } from 'react-router';

import { StepsUpdateContext } from '../Steps/StepsContext';
import styles from './BackButton.module.scss';

interface BackButtonProps {
  ariaLabel?: string;
  text: string;
  useRouter?: boolean;
}

const BackButton: FC<BackButtonProps> = ({ text, ariaLabel, useRouter }) => {
  const { navigateToPrevStep } = useContext(StepsUpdateContext);
  const navigate = useNavigate();
  const btnClassNames = classNames(styles.btn, styles.backBtn);

  const navigateBack = (): void => {
    navigateToPrevStep();
  };

  return (
    <button
      aria-label={ariaLabel}
      className={btnClassNames}
      onClick={() => useRouter ? navigate(-1) : navigateBack()}
      tabIndex={0}
    >
      <i className="material-icons">chevron_left</i>
      <span>{text}</span>
    </button>
  );
};

export default BackButton;
